export default "__VITE_ASSET__CTOvU$k9__"